import React from "react";

type Tone = "default" | "brand" | "success" | "warning" | "danger";

const ICON_TONE: Record<Tone, string> = {
  default: "bg-bg text-textLight",
  brand: "bg-brand/10 text-brand",
  success: "bg-success-bg text-success-text",
  warning: "bg-warning-bg text-warning-text",
  danger: "bg-danger-bg text-danger-text",
};

export function StatCard({
  label,
  value,
  hint,
  tone = "default",
  icon: Icon,
}: {
  label: string;
  value: React.ReactNode;
  hint?: string;
  tone?: Tone;
  icon?: React.ComponentType<{ size?: number; className?: string }>;
}) {
  return (
    <div className="flex items-center gap-md p-md rounded-lg bg-surface border border-border shadow-card">
      {Icon && (
        <div className={`h-10 w-10 rounded-md flex items-center justify-center shrink-0 ${ICON_TONE[tone]}`}>
          <Icon size={20} />
        </div>
      )}
      <div className="min-w-0">
        <div className="text-xs text-textLight">{label}</div>
        <div className="text-xl font-semibold text-text tabular-nums">{value}</div>
        {hint && <div className="text-xs text-textLight truncate">{hint}</div>}
      </div>
    </div>
  );
}
